import { Component, EventEmitter, OnDestroy, OnInit, } from '@angular/core';
import {
  AbstractBlModal,
  ModalButtonType,
  ModalOption,
  ModalSize,
  TableHeader,
} from '@blcloud/bl-ng-ui-component';
import { DealsMemoFixedFormatSettingResource } from '@blcloud/bl-ng-resource';
import { map, switchMap, takeUntil } from 'rxjs/operators';
import { BlConditionType } from '@blcloud/bl-ng-common';
import { IDealsMemoFixedFormatSetting } from '@blcloud/bl-datamodel';
import { LogicalDeleteDiv } from '@blcloud/bl-datamodel/enum/common/logical-delete-div';
import {
  LoginResourceService,
} from '@blcloud/bl-ng-share-module';

/**
 * メモ定型文選択モーダル
 */
@Component({
  templateUrl: 'fixed-format-memo-modal.component.html',
  styleUrls: ['fixed-format-memo-modal.component.scss']
})
export class FixedFormatMemoModalComponent extends AbstractBlModal implements OnInit, OnDestroy {

  /** モーダルウィンドウボタンタイプ */
  readonly modalButtonType = ModalButtonType;

  /** データリスト */
  dealsMemoFixedFormatSettingList: IDealsMemoFixedFormatSetting[] = [];

  /** 選択データ */
  selectedData: IDealsMemoFixedFormatSetting = null;

  /** 最終更新者情報テーブル：ヘッダ */
  headers: TableHeader[] = [
    { key: 'dealsMemoFixedFormat', label: '商談メモ定型文', width: '100%' },
  ];

  private readonly onDestroy$ = new EventEmitter();

  constructor(
    private resource: DealsMemoFixedFormatSettingResource,
    private loginResourceService: LoginResourceService,
  ) {
    super();
  }

  ngOnInit() {
    this.showLoading();
  }

  ngOnDestroy() {
    this.onDestroy$.emit();
  }

  /**
   * 表示用データ初期化
   */
  private initData() {
    this.getDealsMemoFixedFormatSettingList()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(res => {
        this.hideLoading();
        this.dealsMemoFixedFormatSettingList = res;
      }
    );
  }

  /**
   * @override
   */
  onShown() {
    this.initData();
  }

  /**
   * @override
   */
  defaultOption(): ModalOption {
    return { size: ModalSize.Large };
  }

  /**
   * @override
   */
  getResults() {
    return this.selectedData;
  }

  onChangeSelectedRow(val) {
    this.selectedData = val;
  }

  /**
   * 商談メモ定型文一覧取得
   */
  private getDealsMemoFixedFormatSettingList() {
    return this.loginResourceService.getLoginUserEmployeeBindModel()
      .pipe(
        takeUntil(this.onDestroy$),
        switchMap(loginInfo => {
          const conditions = [
            {
              key: 'organizationCode',
              value: loginInfo.organizationCode,
              type: BlConditionType.Equal,
            },
            {
              key: 'logicalDeleteDiv',
              value: LogicalDeleteDiv.Valid,
              type: BlConditionType.Equal,
            }
          ];
          return this.resource.getAll({ conditions }).pipe(map(res => {
            return res ? res.searchResultList : [];
          }));
        }
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/page/profile-entries-page/fixed-format-memo-modal/fixed-format-memo-modal.component.ts